var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretakerIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1311 -1808)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 10,
    transform: "translate(1311 1808)",
    fill: "#ffbe8d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(1362 1817)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1308.988 1809.846)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.014 7.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.835,51.942a11.105,11.105,0,0,1,1.8-6.732c5.174-6.714,7.469-12.531,6.386-19.69-1.755-11.6-9.95-17.748-21.279-18.33C29.364,6.549,18.76,14.5,19.1,25.47c.045,1.448.3,3.58.292,4.973C19.382,35.39,15.1,37.423,15.018,39c-.135,2.586,2.9,1.778,3.973,5.436,1.36,4.644-.591,9.94,5.739,9.613,2.525-.1,6.629-1.082,8.388.554,1.121,1.043,2.025,5.593,2.377,7.607a1.167,1.167,0,0,0,1.151.965h19a1.167,1.167,0,0,0,1.124-1.492A50.41,50.41,0,0,1,54.835,51.942Zm-31.9-35.765c5.371-.711,18.037.171,28.442,2.37-3.6-2.508-10.507-6.984-16.178-8.706a.616.616,0,1,1,.357-1.179c7.918,2.4,17.778,9.734,18.922,10.6a48.02,48.02,0,0,1,6.486,2.048.616.616,0,1,1-.468,1.139,47.249,47.249,0,0,0-6.438-2.024C43.347,17.762,28.875,16.632,23.092,17.4a.616.616,0,1,1-.162-1.221Zm9.258,10.8a73.6,73.6,0,0,0-11.609-.518.617.617,0,1,1-.062-1.232,74.6,74.6,0,0,1,11.851.528c4.786.534,9.711,1.349,14.474,2.138,5.483.908,10.661,1.765,14.89,2.063a.616.616,0,0,1-.042,1.232h-.044c-4.287-.3-9.493-1.164-15-2.076-2.485-.411-5.013-.828-7.539-1.21,2.643,1.031,4.779,2.1,6.873,3.158a50.935,50.935,0,0,0,13.8,5.109.616.616,0,0,1-.259,1.2,51.977,51.977,0,0,1-14.1-5.214A59.912,59.912,0,0,0,32.189,26.976Z",
    transform: "translate(-15.014 -7.154)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretakerIcon4);
export default __webpack_public_path__ + "static/media/caretaker-icon4.88fa4ea7c1144c0facf2112f5341f135.svg";
export { ForwardRef as ReactComponent };